import * as React from "react";
import { stopScrollPropagation } from "./scroll-utils";

/**
 * Componente wrapper que isola o scroll interno, impedindo que eventos de 
 * mouse wheel ou touch se propaguem para elementos pai (body, modais, etc).
 */
export const ScrollIsolation = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ children, ...props }, ref) => (
  <div
    ref={ref}
    onWheel={stopScrollPropagation}
    onTouchStart={stopScrollPropagation}
    onTouchMove={stopScrollPropagation}
    {...props}
  >
    {children}
  </div>
));

ScrollIsolation.displayName = "ScrollIsolation";
